import GetData from "@/utils/request.js"

const {
  $get,
  $post
} = new GetData();

export const myOfflineCourseList = ({ pageNum = 1, pageSize = 15, ticketType = 1, userId }) => {
  return $get('/h5/offline/myOffLineCourselist', { pageNum, pageSize, ticketType, userId });
}
export const myOrderList = ({
  userId,
  pageSize = 15,
  ct,
}) => {
  return $get('/h5/myorder/getOrderListH5', {
    userId,
    pageSize,
    ct,
  })
}

export const myCouponList = ({ pageNum = 1, pageSize = 15, }) => {
  return $get('/h5/coupon/myCouponList', { pageNum, pageSize })
}

export const messageUnreadCount = () => {
  return $get('/h5/message/getUnReadCount')
}

export const messageList = ({ pageNum = 1, pageSize = 15 }) => {
  return $get('/h5/message/list', { pageNum, pageSize })
}

export const readAllMessage = () => $get('/h5/message/readAll')

export const getUserInfo = () => {
  return $post('/h5/account/userInfo')
}

export const getMyCourseList = (data) => {
  return $get(`/h5/user/course/mylist`, data)
}

export const getCourseCount = () => $get('/h5/user/course/countCourse')

export const getGradeList = ({ pageNum = 1, trainCampId }) => $get('/h5/userGrade/list', {
  pageSize: 15,
  pageNum,
  trainCampId,
})

export const getMyGrade = (trainCampId) => $get('/h5/userGrade/getMyGrade', { trainCampId })

export const getMyGradeRecord = ({ pageNum = 1, trainCampId }) => $get('/h5/userGrade/getMyGradeRecord', {
  pageSize: 15,
  pageNum,
  trainCampId,
})
// 邀请码
export const getCourseByCode = id => $get('/h5/invite/getCourseByCode?inviteId='+id)

export const getInviteCodeInfo = id => $get('/h5/invite/getInviteCodeInfo?inviteId='+id)


export default {
  myOfflineCourseList,
  myOrderList,
  myCouponList,
  messageUnreadCount,
  messageList,
  getUserInfo,
  getMyCourseList,
  getCourseCount,
  readAllMessage,
  getGradeList,
  getMyGrade,
  getMyGradeRecord,
  getCourseByCode,
  getInviteCodeInfo
}